import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
/**
* THIS IS AN AUTO GENERATED FILE, CHANGES WILL NOT APPLY
*/

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M4.212 14c1.37 0 2.797.258 2.797-1 0-1.847-2.708-.32-4.208-1.436-2.08-1.546.32-4.814 2.446-3.123a4.969 4.969 0 011.527-5.242C9.679.703 14.16 2.332 14.903 6.01c3.006-.108 4.222 3.799 1.826 5.439-1.717 1.174-3.725-.157-3.725 1.551a1 1 0 001 1c.999 0 2.647.106 4.277-1.298 2.997-2.579 1.878-7.337-1.833-8.465 0 0-.704-1.816-2.558-3.059A6.952 6.952 0 0010.007 0C6.449 0 3.519 2.659 3.076 6.097c0 0-1.431.321-2.344 1.621C-1.176 10.44.878 14 4.212 14m15.787 5a1 1 0 01-1 1H1.014a1 1 0 010-2h7.994V7c0-.552.423-1 .975-1h.008c.552 0 1.016.448 1.016 1v11H19a1 1 0 011 1",
  fillRule: "evenodd"
});

var CloudConnectionIcon = function CloudConnectionIcon(_ref) {
  var className = _ref.className,
      size = _ref.size,
      rest = _objectWithoutProperties(_ref, ["className", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    className: className,
    style: {
      width: size * 10,
      height: size * 10
    },
    fill: "undefined",
    focusable: "false"
  }, rest), _ref2);
};

process.env.NODE_ENV !== "production" ? void 0 : void 0;
CloudConnectionIcon.defaultProps = {
  size: 1.5
};
export default CloudConnectionIcon;